var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoxGreenCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 357,
    height: 188,
    viewBox: "0 0 357 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 355,
    height: 186,
    rx: 11,
    fill: "#2BA75D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 95C61.8985 95 91 65.8985 91 30C91 -5.89851 61.8985 -35 26 -35C-9.89851 -35 -39 -5.89851 -39 30C-39 65.8985 -9.89851 95 26 95Z",
    fill: "url(#paint0_linear_2_47)",
    fillOpacity: 0.2
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 128,
    width: 148,
    height: 60,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2_47",
    transform: "scale(0.00675676 0.0166667)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_47",
    x1: 109.02,
    y1: 98.2178,
    x2: -12.6139,
    y2: -15.6931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "white",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_47"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 95,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2_47",
    width: 148,
    height: 60,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJQAAAA8CAYAAACAc5NXAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFMSURBVHgB7dqxbQIxGIZhO6JIQckIKRgg+0+QASgYgTIFBdJhSy4o0EmGXzojP690ScSRJ40LAl9OpWVZvsu3Y7n25dqV61Kuc875ml6IN6+X283fduOxW7n+ev8ob27vq3z5eXIztceOqT/exF49UIeVX96n/ngTe/VA3VaesEv98Sb26oH6X3nCJfXHm9irB+qUnp+6+tg59ceb2Mv1p/bKvb7YOrQb9RSe3vy3kseTJEmSJH10j28b+LSc97ZnbcCzNuCN61kb8EI9awNeqGdtwAv1rA14oZ61AW9zT5IkSZI0atYGvFDP2oBnbcAb17M24IV61ga8UM/agBfqWRvwQj1rA97mniRJkiRp1KwNeKGetQHP2oA3rmdtwAv1rA14oZ61AS/UszbghXrWBrzNPUmSJEnSqFkb8EI9awOetQFvXM/agBfq3QFoi58he3wsPAAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxGreenCard);
export default __webpack_public_path__ + "static/media/box-green-card.f4bf3cf6e55dc4601d3c3bf738fcaca1.svg";
export { ForwardRef as ReactComponent };